import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=3e58c2b2&scoped=true&"
import script from "./DocumentTable.vue?vue&type=script&lang=js&"
export * from "./DocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=3e58c2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58c2b2",
  null
  
)

export default component.exports